import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import RenderTextField from '../common/RenderTextField';
import { nowTimestamp } from '../../utils/dates';
import { INSUFFICIENT_REQUEST } from '../../utils/api-errors-const';
import { updatePasswordSettings } from '../../actions/user-actions';
import DialogForm from '../common/DialogForm';
import CommonPasswordFields from './CommonPasswordFields';
import { Field } from 'formik';
import { validatePassword } from '../../utils/validators';
import {darkenOrLighten, BLACK_COLOR} from "../../utils/color-const";

const CHANGE_PASSWORD_ACTION = 'personal.settings.update.password';

const PasswordActionWrapper = styled('div')({
    fontSize: '12px',
    paddingTop: '16px',
    textAlign: 'left',
});

const GreyActionText = styled('span')({
    color: BLACK_COLOR,

    '&:hover': {
        color: darkenOrLighten(BLACK_COLOR),
        cursor: 'pointer',
    },
});

//TODO check validation
class PasswordSettingsForm extends React.Component {

  static propTypes = {
    apiResult: PropTypes.object,
    updatePasswordSettings: PropTypes.func,
  };

  state = {
    changePasswordDialogOpened: false,
    error: null,
  };

  static getDerivedStateFromProps(nextProps) {
    const { apiResult } = nextProps;

    if (apiResult && apiResult.requestId && apiResult.requestId.startsWith(CHANGE_PASSWORD_ACTION)) {
      if (apiResult.success) {
        return { changePasswordDialogOpened: false };
      } else if (apiResult.group) {
        let message = 'Nieznany błąd. Spróbuj ponownie później.';
        return { error: message };
      }
    }
    return null;
  }

  render() {
    const { updatePasswordSettings } = this.props;
    const { changePasswordDialogOpened, error } = this.state;
    return (
      <>
        <PasswordActionWrapper>
          <GreyActionText onClick={this.handleToggleChangePasswordDialog.bind(this)}>
          Chcę zmienić hasło
          </GreyActionText>
        </PasswordActionWrapper>

        <DialogForm
          open={changePasswordDialogOpened}
          onSubmit={updatePasswordSettings.bind(this, `${CHANGE_PASSWORD_ACTION}.${nowTimestamp()}`)}
          onCancel={this.handleToggleChangePasswordDialog.bind(this)}
          title="Zmień hasło"
          formContent={this.renderFields.bind(this)}
          initialValues={{
            oldPassword: '',
            password: '',
            newPassword: '',
          }}
          error={error}
          DialogProps={{ hideBackdrop: true }} />
      </>
    );
  }

  renderFields(values) {
    return (
      <>

        <CommonPasswordFields
          changePassword
          withoutIcons
          password={values.password}
          repeatPassword={values.newPassword} />
      </>
    );
  }

  handleToggleChangePasswordDialog() {
    this.setState(prevState => ({
      changePasswordDialogOpened: !prevState.changePasswordDialogOpened,
    }));
  }

}

export default connect(
  store => ({ apiResult: store.api.requestResult }),
  dispatch => bindActionCreators({ updatePasswordSettings }, dispatch)
)(PasswordSettingsForm);
